import React from 'react';

export default function SvgRegisterIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor" {...props}>
            <g clipPath="url(#clip0_2360_32714)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.93934 0.93934C3.22064 0.658035 3.60218 0.5 4 0.5H10C10.3978 0.5 10.7794 0.658035 11.0607 0.93934C11.342 1.22064 11.5 1.60217 11.5 2V10C11.5 10.3978 11.342 10.7794 11.0607 11.0607C10.7794 11.342 10.3978 11.5 10 11.5H2C1.60217 11.5 1.22064 11.342 0.93934 11.0607C0.658035 10.7794 0.5 10.3978 0.5 10V5.5C0.5 4.67386 1.17386 4 2 4H2.5V2C2.5 1.60218 2.65804 1.22064 2.93934 0.93934ZM2.5 5H2C1.72614 5 1.5 5.22614 1.5 5.5V10C1.5 10.1326 1.55268 10.2598 1.64645 10.3536C1.74021 10.4473 1.86739 10.5 2 10.5C2.13261 10.5 2.25979 10.4473 2.35355 10.3536C2.44732 10.2598 2.5 10.1326 2.5 10V5ZM3.41421 10.5C3.47047 10.3409 3.5 10.172 3.5 10V2C3.5 1.86739 3.55268 1.74021 3.64645 1.64645C3.74021 1.55268 3.86739 1.5 4 1.5H10C10.1326 1.5 10.2598 1.55268 10.3536 1.64645C10.4473 1.74021 10.5 1.86739 10.5 2V10C10.5 10.1326 10.4473 10.2598 10.3536 10.3536C10.2598 10.4473 10.1326 10.5 10 10.5H3.41421Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 7C4.5 6.72386 4.72386 6.5 5 6.5H9C9.27614 6.5 9.5 6.72386 9.5 7C9.5 7.27614 9.27614 7.5 9 7.5H5C4.72386 7.5 4.5 7.27614 4.5 7Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 9C4.5 8.72386 4.72386 8.5 5 8.5H7.5C7.77614 8.5 8 8.72386 8 9C8 9.27614 7.77614 9.5 7.5 9.5H5C4.72386 9.5 4.5 9.27614 4.5 9Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 3C4.5 2.72386 4.72386 2.5 5 2.5H9C9.27614 2.5 9.5 2.72386 9.5 3V5C9.5 5.27614 9.27614 5.5 9 5.5H5C4.72386 5.5 4.5 5.27614 4.5 5V3ZM5.5 3.5V4.5H8.5V3.5H5.5Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2360_32714">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
